import { Charts } from './Charts';
import StratifiedProductionChartsDataProvider from './contexts/StratifiedProductionChartsDataContext';

const StratifiedProductionWrapper = () => {
    return (
        <StratifiedProductionChartsDataProvider>
            <Charts />
        </StratifiedProductionChartsDataProvider>
    );
};

export default StratifiedProductionWrapper;
